module.exports = __webpack_public_path__ + "img/l_Node-js.6a03548a.svg";